import React, { useState } from "react";
import {
  Box,
  Button,
  Center,
  Circle,
  Flex,
  Square,
  Text,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../../../services/api";
import companyLogo from "../../../Assets/company.png";

const Jobrole_Comp = (props) => {
  const { role, company, recruiter } = props;
  const navigate = useNavigate();
  const [hoverState, sethoverState] = useState(false);
  const [createdBy, setCreatedBy] = useState({
    name: "",
    profilePhoto: "",
  });

  const handleHover = () => {
    sethoverState(true);
  };
  const handleLeave = () => {
    sethoverState(false);
  };
  const sliceText = (text) => {
    if (text.length >= 30) {
      const sliced = text.slice(0, 31);
      return `${sliced}...`;
    }
    return text;
  };

  const detailsHandler = () => {
    navigate(`/hiring/recruiter/details/${props.id}`);
  };

  useEffect(() => {
    if (props.recruiter) {
      api.getUserById(props.recruiter).then((res) =>
        setCreatedBy({
          name: res.data.data.name,
          profilePhoto: res.data.data.profilePhoto,
        })
      );
    }
  }, [props.recruiter]);
  return (
    <div>
      <Box
        border="1px solid #ADADAD"
        p={[1, 1, 5, 5]}
        w={[326, 326, 326, 326, 326, 430, 430]}
        borderRadius={10}
        _hover={{ boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.13)" }}
        onMouseEnter={handleHover}
        onMouseLeave={handleLeave}
      >
        {/* Main Flex */}
        <Flex flexDir="column" gap={4}>
          <Flex align="center" gap={3}>
            <Square size={14}>
              <img src={companyLogo} alt="" />
            </Square>
            <Box>
              {/* Title */}
              <Text
                textAlign="left"
                fontFamily={"Roboto"}
                fontSize={20}
                fontWeight={550}
              >
                {role}
              </Text>
              {/* Company name */}
              {company && (
                <Text
                  textAlign="left"
                  fontFamily={"Roboto"}
                  fontSize={16}
                  fontWeight={450}
                >
                  {sliceText(company)}
                </Text>
              )}
            </Box>
          </Flex>
          {/* recruiter name */}
          <Text>Created by</Text>
          {createdBy.name && (
            <Flex align="center" gap={3}>
              <Circle size={12} bg="#D9D9D9" ml={1} overflow="hidden">
                {/* Icon */}
                <Center>
                  {createdBy?.profilePhoto && (
                    <img src={createdBy?.profilePhoto} alt="created by" />
                  )}
                </Center>
              </Circle>
              <Text fontSize={16} fontWeight={600}>
                {createdBy?.name}
              </Text>
            </Flex>
          )}
          {/* View Details */}
          <Button
            borderRadius={12}
            variant="unstyled"
            w="100%"
            h={41}
            alignItems="center"
            fontSize={16}
            fontWeight="semibold"
            mb={0}
            border={hoverState ? "" : "1px solid #E7E6E8"}
            color={hoverState ? "#FFFFFF" : ""}
            bg={hoverState ? "#6C56FB" : ""}
            _hover={{
              boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
            }}
            onClick={detailsHandler}
          >
            View details
          </Button>
        </Flex>
      </Box>
    </div>
  );
};
export default Jobrole_Comp;
